import {Button} from "antd";
import React from "react";
import theme from "../theme";
import {useMediaQuery} from "react-responsive";

const PmBigButton = ({ icon, text, bgColor = theme.colors.secondary, ...props }) => {
    const isMobile = useMediaQuery({maxWidth: 800});
    return (
        <Button
            style={{
                backgroundColor: bgColor,
                height: isMobile ? "140px" : "160px",
                width: "100%",
                borderRadius: "12px",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "center",
                paddingTop: "24px",
                border: "none",
                cursor: "pointer",
                ...props.style,
            }}
            className={`text-white hover:bg-opacity-90 ${props.className || ""}`}
            {...props}
        >
            {icon && React.cloneElement(icon, { style: { fontSize: "48px", marginBottom: "24px", color: "white" } })}
            <span style={{ color: "white", fontSize: "1rem", fontWeight: "600" }}>{text}</span>
        </Button>
    );
};

export default PmBigButton;